<div class="loader-backdrop" *ngIf="requestInProcess > 0">
  <div class="loader-container">
    <span class="loader"></span>
  </div>
</div>
